import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { FC } from "react";
import ProjectBanner from "./ProjectBanner";
import PoolInfoTabSection from "./PoolInfoTabSection";
import { Skeleton } from "@material-ui/lab";
import HorizontalStepper from "./Stepper";

const BannerSkeleton: FC<any> = () => {
    const theme = useTheme();
    const isActive = useMediaQuery(theme.breakpoints.down("sm"));
    return (
        <Skeleton height={isActive ? 140: 350} variant="rect" animation="wave"
            style={{
                borderRadius: "17px",
            }}
        />
    )
}

const Detail: FC<any> = ({ poolData, poolContent }) => {

    const getActiveStepIndex = (status: string): number => {
        switch (status) {
          case "upcoming":
            return 0; 
          case "whitelist_open":
            return 1; 
          case "whitelist_closed":
            return 2; 
          case "ongoing":
            return 3; 
          case "closed":
          case "cancelled":
          case "refunded":
            return 4; 
          default:
            return -1;
        }
      };

    return (
        <>
            <Grid
                container
                direction="column"
                style={{
                    display: "block",
                }} 
            >
                <Grid
                    item
                >
                    {
                        !poolData || !poolData.spotlight
                            ? <BannerSkeleton />
                            : <ProjectBanner name={poolData.name} spotlight={poolData.spotlight} />
                    }
                </Grid>
                <Grid
                    item
                >
                   <HorizontalStepper activeStep={getActiveStepIndex(poolData?.status)}/>
                </Grid>
                <Grid
                    item
                >
                    <PoolInfoTabSection poolContent={poolContent} poolData={poolData} />
                </Grid>
            </Grid>
        </>
    )
}

export default Detail;